import { createContext, useContext, ReactNode } from 'react';

interface OverlayContextType {
  overlay: boolean;
}

const OverlayContext = createContext<OverlayContextType>({ overlay: false });

interface OverlayProviderProps {
  children: ReactNode;
  value: OverlayContextType;
}

export const OverlayProvider = ({ children, value }: OverlayProviderProps) => {
  return <OverlayContext.Provider value={value}>{children}</OverlayContext.Provider>;
};

export const useOverlay = () => useContext(OverlayContext);
